"use client"

import { useEffect } from "react"

import { recoverFromServerActionDeploymentMismatch } from "@/lib/client/deployment-recovery"

export function DeploymentRecovery() {
  useEffect(() => {
    function handleError(event: ErrorEvent) {
      recoverFromServerActionDeploymentMismatch(event.error || event.message)
    }

    function handleUnhandledRejection(event: PromiseRejectionEvent) {
      recoverFromServerActionDeploymentMismatch(event.reason)
    }

    window.addEventListener("error", handleError)
    window.addEventListener("unhandledrejection", handleUnhandledRejection)

    return () => {
      window.removeEventListener("error", handleError)
      window.removeEventListener("unhandledrejection", handleUnhandledRejection)
    }
  }, [])

  return null
}
